module.exports = __webpack_public_path__ + "media/C_hand_apparition.fc2981bb.mp3";